import React from 'react';
import { Link } from 'react-router-dom';
import { successReasons } from '../../content/siteData';

function Success() {
  return (
    <main className="gop-page">
      <section className="gop-page-hero">
        <div className="gop-container">
          <span className="gop-eyebrow">Why Clients Trust Us</span>
          <h1>Success comes from clarity, structure, and consistent support.</h1>
          <p>
            We focus on building stronger applications and calmer decision-making instead of
            creating more confusion during already stressful processes.
          </p>
        </div>
      </section>

      <section className="gop-page-section">
        <div className="gop-container gop-page-grid">
          {successReasons.map((item) => (
            <article key={item.title} className="gop-page-card">
              <strong>{item.title}</strong>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="gop-mini-cta">
        <div className="gop-container gop-mini-cta__inner">
          <div>
            <h2>Ready for a clearer plan?</h2>
            <p>Let us help you reduce guesswork and move with stronger preparation.</p>
          </div>
          <Link to="/contact" className="gop-btn gop-btn--primary">
            Start Your Discussion
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Success;
